import React, { Component } from "react";
import { connect } from "react-redux";
import {
    Form,
    FormItem,
    ModalItem,
    ButtonItem,
    ErrorItem,
    InputNumberItem,
    SelectFraccionArancelariaItem,
    SelectUnidadAduanaItem,
} from "../../../../Components/Items";


class ComercioExteriorInsumo extends Component {
    formRefComercioExterior = React.createRef();
    state = {
        loading: false,
    };

    componentDidUpdate(prevProps) {
        if (this.props.visible !== prevProps.visible && this.props.visible) {
            if (this.formRefComercioExterior.current) {
                this.formRefComercioExterior.current.setFieldsValue(this.props.values)
            }
        }
    }

    cerrarComercioExteriorInsumo() {
        const values = this.formRefComercioExterior.current.getFieldsValue()
        this.props.cerrarComercioExteriorInsumo(values);
        this.formRefComercioExterior.current.resetFields()
    }

    onFinish() {
        this.cerrarComercioExteriorInsumo()
    }

    onFinishFailed(e) {
        ErrorItem(e);
    }

    render() {
        return (
            <>
                <ModalItem
                    title="Comercio Exterior Insumo"
                    visible={this.props.visible}
                    spinning={this.state.loading}
                    onCancel={this.cerrarComercioExteriorInsumo.bind(this)}
                    paddingTop
                    width={700}
                >
                    <Form
                        ref={this.formRefComercioExterior}
                        name="comercioExteriorInsumo"
                        layout
                        bottom={
                            <ButtonItem
                                type="primary"
                                htmlType="submit"
                                style={{ display: "block", margin: "0 0 0 auto" }}
                            >
                                Guardar
                            </ButtonItem>
                        }
                        onFinish={this.onFinish.bind(this)}
                        onFinishFailed={this.onFinishFailed}
                    >
                        <FormItem
                            name="fraccionArancelariaId"
                            label="Fracción Arancelaria"
                            margin
                        >
                            <SelectFraccionArancelariaItem
                                empresaId={this.props.empresaId} // o donde sea que tengas almacenado el ID de la empresa
                                headersToken={this.props.headersToken}
                                sinBorde
                                autoFocus
                                dropdownMatchSelectWidth={600}
                                width="100%"
                                placeholder="Fracción Arancelaria"
                            />
                        </FormItem>
                        <FormItem
                            name='valorUnitarioAduana'
                            label="Valor Unitario Aduana"
                            pattern
                            margin
                            tooltip="Valor unitario en dolares en aduana del insumo para comercio exterior."
                        >
                            <InputNumberItem
                                dinero
                                placeholder="Escribe la cantidad aduana"
                                onChange={(value) => {
                                    const cantidadAduana = this.formRefComercioExterior.current.getFieldValue('cantidadAduana') || 0;
                                    if (value && cantidadAduana) {
                                        const valorDolares = value * cantidadAduana;
                                        this.formRefComercioExterior.current.setFieldsValue({ valorDolares });
                                    }
                                }}
                            />
                        </FormItem>
                        <FormItem
                            name="unidadAduanaId"
                            label="Unidad Aduana"
                            margin
                        >
                            <SelectUnidadAduanaItem
                                empresaId={this.props.empresaId} // o donde sea que tengas almacenado el ID de la empresa
                                headersToken={this.props.headersToken}
                                sinBorde
                                autoFocus
                                dropdownMatchSelectWidth={600}
                                width="100%"
                                placeholder="Unidad Aduana"
                            />
                        </FormItem>
                        <FormItem
                            name="cantidadAduana"
                            label="Cantidad Aduana"
                            pattern
                            margin
                            tooltip="Cantidad en aduana del insumo para comercio exterior."
                        >
                            <InputNumberItem
                                placeholder="Escribe la cantidad aduana"
                                onChange={(value) => {
                                    const valorUnitarioAduana = this.formRefComercioExterior.current.getFieldValue('valorUnitarioAduana') || 0;
                                    if (value && valorUnitarioAduana) {
                                        const valorDolares = value * valorUnitarioAduana;
                                        this.formRefComercioExterior.current.setFieldsValue({ valorDolares });
                                    }
                                }}
                            />
                        </FormItem>
                        <FormItem
                            name='valorDolares'
                            label="Valor Dólares"
                            pattern
                            margin
                            tooltip="Valor total en dólares del insumo para comercio exterior."
                        >
                            <InputNumberItem
                                dinero
                                placeholder="Escribe el valor en dólares"
                            />
                        </FormItem>
                    </Form>
                </ModalItem>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
    };
};

export default connect(mapStateToProps)(ComercioExteriorInsumo);
